import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import SafeImage from "components/SafeImage";
import { getCampaings } from "firestoreService";

const PREVIEW_COUNT = 6;

function Campaings() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const load = async () => {
      try {
        const result = await getCampaings();
        if (active) setImages(Array.isArray(result?.data) ? result.data : []);
      } catch (error) {
        console.error("Could not load campaigns:", error);
      } finally {
        if (active) setLoading(false);
      }
    };

    load();
    return () => {
      active = false;
    };
  }, []);

  if (!loading && images.length === 0) return null;

  return (
    <MKBox
      component="section"
      py={{ xs: 5, md: 8 }}
      sx={{ bgcolor: ({ palette: { brand } }) => brand.mist }}
    >
      <Container>
        <MKBox textAlign="center" mb={{ xs: 4, md: 6 }} mx="auto" maxWidth="640px">
          <MKTypography variant="h2" mb={1.5} sx={{ fontSize: { xs: "1.6rem", md: "2.25rem" } }}>
            Our campaigns
          </MKTypography>
          <MKTypography variant="body2" color="text">
            Education drives and community programmes we run across Delhi NCR.
          </MKTypography>
        </MKBox>

        <Grid container spacing={3}>
          {loading
            ? [0, 1, 2].map((key) => (
                <Grid item xs={12} sm={6} md={4} key={key}>
                  <Skeleton variant="rounded" sx={{ aspectRatio: "3 / 4", height: "auto" }} />
                </Grid>
              ))
            : images.slice(0, PREVIEW_COUNT).map((image) => (
                <Grid item xs={12} sm={6} md={4} key={image}>
                  <Card sx={{ borderRadius: 3, overflow: "hidden", boxShadow: "none" }}>
                    <SafeImage src={image} alt="A1 Home Tutors campaign" />
                  </Card>
                </Grid>
              ))}
        </Grid>

        {!loading && images.length > PREVIEW_COUNT && (
          <MKBox textAlign="center" mt={4}>
            <MKButton component={Link} to="/campaign" variant="outlined" color="primary">
              See all campaigns
            </MKButton>
          </MKBox>
        )}
      </Container>
    </MKBox>
  );
}

export default Campaings;
